function e(e,t){if(void 0!==e.fontSize){var f=t&&t.fontSizes&&t.fontSizes[e.fontSize]||e.fontSize;e.fontSize="number"==typeof f?f+"px":f}return e}export{e as default};
//# sourceMappingURL=typography.js.map
